import React from 'react';

const SumoRobotCompetition: React.FC = () => {
  return (
    <div className="text-justify py-4">
      <p className="mb-4">
        Kompetisi <b>Sumo Robot</b> menjadi salah satu kategori paling seru dan menegangkan di ajang <b>Indonesia Innovative Technology Challenge (IITC) 2024</b>. Dirancang untuk siswa SMP dan SMA, lomba ini menghadirkan adu kekuatan dan strategi antara robot-robot mini yang dirancang dan diprogram oleh para peserta.
      </p>
      
      <h2 className="text-2xl font-bold mb-4 mt-6">Apa Itu Kompetisi Sumo Robot?</h2>
      <p className="mb-6">
        Dalam kompetisi ini, robot yang dirancang oleh peserta harus beradu untuk saling mendorong keluar dari arena berbentuk lingkaran, yang dikenal sebagai <i>dohyo</i>. Robot-robot ini dikendalikan secara otomatis menggunakan program yang telah diintegrasikan sebelumnya.
      </p>
      
      <h2 className="text-2xl font-bold mb-4 mt-6">Belajar dari Kompetisi Sumo Robot</h2>
      <p className="mb-4">
        Tidak hanya penuh keseruan, kompetisi ini juga menjadi ajang pembelajaran berharga bagi para peserta:
      </p>
      
      <ol className="list-decimal pl-6 mb-6 space-y-4">
        <li>
          <p><strong>Mengasah Kemampuan Teknologi</strong></p>
          <p>
            Peserta belajar merancang, membangun, dan memprogram robot yang sesuai dengan kebutuhan kompetisi.
          </p>
        </li>
        <li>
          <p><strong>Melatih Kerja Tim</strong></p>
          <p>
            Sebagian besar peserta bekerja dalam tim, sehingga mereka harus belajar berkolaborasi dan berbagi ide untuk mencapai hasil terbaik.
          </p>
        </li>
        <li>
          <p><strong>Belajar Strategi dan Analisis</strong></p>
          <p>
            Selain kekuatan fisik robot, strategi memainkan peran penting. Peserta dituntut untuk menganalisis lawan dan merancang program yang dapat mengunggulinya.
          </p>
        </li>
      </ol>
      
      <h2 className="text-2xl font-bold mb-4 mt-6">Membangun Generasi Inovator</h2>
      <p className="mb-6">
        Kompetisi Sumo Robot tidak hanya memacu adrenalin, tetapi juga menunjukkan potensi besar generasi muda Indonesia di bidang teknologi dan robotika. Dengan kompetisi seperti ini, IITC 2024 berhasil menciptakan platform untuk mengasah keterampilan sekaligus menyalurkan kreativitas anak-anak bangsa.
      </p>
      
      <h2 className="text-2xl font-bold mb-4 mt-6">Jelajahi Keseruan IITC 2024</h2>
      <p className="mb-4">
        Untuk informasi lebih lanjut tentang kategori lain dan detail program, kunjungi:
      </p>
      <p className="mb-6">
        <a href="https://iitchallenge.com/iit-program" target='_blank' className="underline font-semibold text-defaultBlue">iitchallenge.com/iit-program</a>
      </p>
      <p>
        <b>Mari dukung generasi muda untuk terus belajar, berinovasi, dan mengembangkan teknologi untuk masa depan!</b>
      </p>
    </div>
  );
};

export default SumoRobotCompetition;